module.exports = function(service) {
	'use strict'
	service.service('alertService',alertService);
	alertService.$inject=['$rootScope','$timeout','createRandomHash'];
	function alertService($rootScope,$timeout,createRandomHash) {
		$rootScope.alerts=[];
		$rootScope.alertShow = false;
		var alertsTimeout = [];
		var alertsWidthClose = []
		var i = -1;
		var j = -1
		var rb = -1;
		return function(type,title,message,timeout) {
			var alertObj = {
				'show':true,
				'type':type,
				'title':title,
				'message':message,
				'close':(timeout)?false:true,
				'id':createRandomHash(10)
			}
			$rootScope.alerts.push(alertObj);
			if(timeout) {
				alertObj.timeout = $timeout(function() {
					var index = $rootScope.alerts.findIndex(function(alert) {		
						return alert.id == alertObj.id;
					});
					if(index != -1) {
						$rootScope.alerts.splice(index,1);	
					}
				},timeout);
			} else {
				$rootScope.alertShow = true;
			}
			$rootScope.closeAlert = function(id) {
				var index = $rootScope.alerts.findIndex(function(alert) {	
					return alert.id == id;
				});
				if(index != -1) {
					$rootScope.alerts.splice(index,1);	
				}
				var closeAlerts = $rootScope.alerts.filter(function(alert) {
					return alert.close;
				});
				if(closeAlerts.length==0) {
					$rootScope.alertShow = false;
				}
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/alertService.js
// module id = 584
// module chunks = 0